
export const MESSAGE = 'MESSAGE';
export const MESSAGE1 = 'MESSAGE1';
export const MESSAGE2 = 'MESSAGE2';
export const MESSAGE3= "MESSAGE3"


export const LOGGEDIN = 'LOGGEDIN';
export const PROFILE = 'PROFILE';


//Sales

export const SEARCH="SEARCH"
export const PRODUCTDETAIL = "PRODUCTDETAIL"
export const ALLSALELIST = "ALLSALELIST"

// Masters
export const CATEGORIES = 'CATEGORIES'
export const ROLELIST = 'ROLELIST'
export const UNITS = "UNITS"



//Product
export const PRODUCTS = "PRODUCTS"

// 
export const CREATETRANSACTION = "CREATETRANSACTION"


// Customer
export const CUSTOMERS = "CUSTOMERS"
export const CUSTOMER = "CUSTOMER"
export const ACTCUSTOMERS = "ACTCUSTOMERS"


// Transaction
export const TRANSACTIONS = "TRANSACTIONS"

// Setting
export const ABOUTUS = "ABOUTUS"
export const PRIVACYPOLICY = "PRIVACYPOLICY"
export const TERMSCONDITIONS = "TERMSCONDITIONS"
export const REFUNDPOLICY = "REFUNDPOLICY"


// Dashboard
export const TOTALUSERS = "TOTALUSERS"


export const TOTALSUBSCRIBEUSER = "TOTALSUBSCRIBEUSER"
export const MONTHLYREVENUE = "MONTHLYREVENUE"
export const TOTALREVENUE = "TOTALREVENUE"
export const TV_SHOW_DASHBOARD = "TV_SHOW_DASHBOARD"
export const RECENT_SUBSCRIBER_DASHBOARD = "RECENT_SUBSCRIBER_DASHBOARD"
export const DAILY_REVENUE = "DAILY_REVENUE"
export const RENEWAL = "RENEWAL"

export const SALESDATA = "SALESDATA" 



// Complaint
export const COMPLAINTS = "COMPLAINTS"
